import Joi from "joi";

export const licenseKey = Joi.string()
  .required()
  .pattern(
    new RegExp("^(\\w{4}-\\w{4}-\\w{4}-\\w{4})|(TE-\\w{4}(-\\w{5}){5})$")
  )
  .label("License Key");
